import { Component, OnInit } from '@angular/core';
import { LocationService } from '../../../_services/location.service';
import { TranslateService } from 'ngx-translate-with-country';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-language-bar',
  templateUrl: './language-bar.component.html',
  styleUrls: ['./language-bar.component.scss']
})
export class LanguageBarComponent implements OnInit {
  country: string;
  language: string;
  query: string;

  countryName: string;
  languageName: string;
  languageCode: string;
  countryCode: string;
  countries: any;

  constructor(
    private router: Router,
    private locationService: LocationService,
    public translateService: TranslateService
  ) {}

  getLocation(countryParam: string, languageParam: string): void {
    this.locationService.getLocation(countryParam, languageParam).subscribe(
      response => {
        this.countries = response;
        for (const countrySingle of this.countries) {
          if (countrySingle.code === countryParam) {
            this.countryName = countrySingle.origName;
            this.countryCode = countrySingle.code;
            console.log(this.countryName)
          }
          for (const language of countrySingle.lang) {
            if (language.code === this.translateService.currentLang) {
              this.languageName = language.origName;
              this.languageCode = this.translateService.currentLang;
            }
          }
          setTimeout(() => {
            $('.app-loading').hide();
            $('body, html').css('overflow', 'unset');
          }, 1000);
        }
      },
      error => console.log('Error ::' + error)
    );
  }

  search() {
    this.router.navigateByUrl('/' + this.country + '/' + this.language + '/search/' + this.query);
    this.query = '';
  }

  ngOnInit() {
    setTimeout(() => {
      this.country = this.locationService.country;
      this.language = this.locationService.langCode;
      console.log(this.country)
      console.log(this.language)
      this.getLocation(this.country, this.language);
    }, 3500);
  }
}
